import React from 'react'

function CardFeaturebox1() {
    return (
        <div className='homebox2main' id='feature-box1'>
            <div className='container'>
                <div className='homebox2'>
                    <div className='homebox2-left'>
                        <img src="/img-engage.webp" alt="hero-img" />
                    </div>
                    <div className='homebox2-right'>
                        <span>Card Management</span>
                        <h2>Simplify Customer Card Experience</h2>
                        <p>Manage digital membership and loyalty cards with a seamless and user-friendly system. Give customers quick access to their card details, rewards, and membership information while keeping everything secure and organized in one place.</p>
                        <h5>Smart Features for Better Management</h5>
                        <ul>
                            <li>Easily create, update, and manage customer cards in real time</li>
                            <li>Provide secure access to membership details and reward information</li>
                            <li>Track customer activity and card usage for better engagement</li>
                            <li>Deliver a smooth digital experience with centralized card management</li>
                            <li>Improve customer retention through personalized card services</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CardFeaturebox1